import jwtDecode from "jwt-decode";
export var getPermissionsFromJWTToken = function (token) {
    var jwt = jwtDecode(token);
    var permissions = jwt.permissions;
    return permissions || [];
};
